import produce from 'immer';

import {
  getAppsFilters,
  getApps,
  getAppsTop,
  appsAutocomplete,
  appsSetAutocompleteDefData,
} from '../actions/apps';

const initialState = {
  filters: {},
  apps: [],
  autocompleteDefData: [],
  autocompleteData: [],
  appsTop: [],
  formData: null,
  loadings: {
    filters: false,
    apps: false,
    appsTop: false,
    autocompleteData: false,
  },
};

const reducer = produce((state = initialState, action) => {
  switch (action.type) {
    // GET FILTERS
    case getAppsFilters.types.START:
      state.loadings.filters = true;
      return state;

    case getAppsFilters.types.SUCCESS:
      state.filters = action.payload.data;
      state.loadings.filters = false;
      return state;

    case getAppsFilters.types.FAIL:
      state.loadings.filters = false;
      return state;

    // GET APPS
    case getApps.types.START:
      state.apps = [];
      state.loadings.apps = true;
      return state;

    case getApps.types.SUCCESS:
      state.apps = action.payload.data;
      state.loadings.apps = false;
      return state;

    case getApps.types.FAIL:
      state.loadings.apps = false;
      return state;

    // GET TOP CHANNELS
    case getAppsTop.types.START:
      state.appsTop = [];
      state.loadings.appsTop = true;
      return state;

    case getAppsTop.types.SUCCESS:
      state.appsTop = action.payload.data;
      state.loadings.appsTop = false;
      return state;

    case getAppsTop.types.FAIL:
      state.loadings.appsTop = false;
      return state;

    // APPS AUTOCOMPLETE
    case appsAutocomplete.types.START:
      state.loadings.autocompleteData = true;
      return state;

    case appsAutocomplete.types.SUCCESS:
      state.autocompleteData = action.payload.data;
      if (action.payload.defData?.length) state.autocompleteDefData = action.payload.defData;
      state.loadings.autocompleteData = false;
      return state;

    case appsAutocomplete.types.FAIL:
      state.loadings.autocompleteData = false;
      return state;

    // SET AUTOCOMPLETE DEF DATA
    case appsSetAutocompleteDefData.types.INIT:
      state.autocompleteData = state.autocompleteDefData;
      return state;

    default:
      return state;
  }
});

export default reducer;
